import { REPORT_REVIEW_STATUSES, RESULT_ENTRY_STATUSES } from 'qap/constants'
import type {
  ChartDataType,
  ReportCountDataType,
  ReportCountItem,
  RoundCountDataType,
  RoundCountItem,
} from './types'

const tallyStats = <T extends { count: number }>(
  data: T[] | undefined,
  filter: (item: T) => boolean
): number => {
  return data?.filter(filter)?.reduce((acc, s) => acc + s.count, 0) || 0
}

export const prepareResultEntryChartData = ({ data }: RoundCountDataType): ChartDataType[] => {
  const missedCount = tallyStats(data, (s: RoundCountItem) => s.status === RESULT_ENTRY_STATUSES.MISSED.value)
  const lateCount = tallyStats(data, (s: RoundCountItem) => s.status === RESULT_ENTRY_STATUSES.LATE.value && s.lateSubmission === true)
  const submittedCount = tallyStats(data, (s: RoundCountItem) => s.status === RESULT_ENTRY_STATUSES.SUBMITTED.value && !!s.lateSubmission === false)

  return [
    { name: RESULT_ENTRY_STATUSES.MISSED.label, value: missedCount },
    { name: RESULT_ENTRY_STATUSES.LATE.label, value: lateCount },
    { name: RESULT_ENTRY_STATUSES.SUBMITTED.label, value: submittedCount },
  ]
}

export const prepareReportCapaChartData = ({ data }: ReportCountDataType): ChartDataType[] => {
  const openCount = tallyStats(data, (s: ReportCountItem) => s.capaStatus === 'open')
  const closedCount = tallyStats(data, (s: ReportCountItem) => s.capaStatus === 'closed')
  return [
    { name: 'Open', value: openCount },
    { name: 'Closed', value: closedCount },
  ]
}

export const prepareReportReviewChartData = ({ data }: ReportCountDataType): ChartDataType[] => {
  const notReviewedCount = tallyStats(data, (s: ReportCountItem) => s.reviewStatus === REPORT_REVIEW_STATUSES.NOT_REVIEWED.value && !s.fresh)
  const overdueCount = tallyStats(data, (s: ReportCountItem) => s.reviewStatus === REPORT_REVIEW_STATUSES.OVERDUE.value)
  const inProgressCount = tallyStats(data, (s: ReportCountItem) => s.reviewStatus === REPORT_REVIEW_STATUSES.IN_PROGRESS.value)
  const doneCount = tallyStats(data, (s: ReportCountItem) => s.reviewStatus === REPORT_REVIEW_STATUSES.DONE.value)
  const signedOffCount = tallyStats(data, (s: ReportCountItem) => s.reviewStatus === REPORT_REVIEW_STATUSES.SIGNED_OFF.value)

  return [
    { name: REPORT_REVIEW_STATUSES.NOT_REVIEWED.label, value: notReviewedCount },
    { name: REPORT_REVIEW_STATUSES.OVERDUE.label, value: overdueCount },
    { name: REPORT_REVIEW_STATUSES.IN_PROGRESS.label, value: inProgressCount },
    { name: REPORT_REVIEW_STATUSES.DONE.label, value: doneCount },
    { name: REPORT_REVIEW_STATUSES.SIGNED_OFF.label, value: signedOffCount },
  ]
}
